import { Grid } from '@mui/material'
import TopSection from '../../components/accounts/list/TopSection'
import MainSection from '../../components/accounts/list/MainSection'
import useGaPageView from '../../hooks/google/useGaPageView'

export default function AccountsList() {
  useGaPageView('Accounts list')
  
  return (
    <Grid width='100%' paddingX='.5rem'>
      <TopSection />
      <MainSection />
    </Grid>
  )
}